// extracted by mini-css-extract-plugin
export var container = "banner--homepage-module--container--0630e";
export var content = "banner--homepage-module--content--f3166";
export var contentWrapper = "banner--homepage-module--content-wrapper--eca97";
export var image = "banner--homepage-module--image--38063";
export var imageWrapper = "banner--homepage-module--image-wrapper--967b6";
export var title = "banner--homepage-module--title--f64f8";